import { render, staticRenderFns } from "./BaseSignPage.vue?vue&type=template&id=3e5c675a&scoped=true&"
import script from "./BaseSignPage.vue?vue&type=script&lang=js&"
export * from "./BaseSignPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseSignPage.vue?vue&type=style&index=0&id=3e5c675a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5c675a",
  null
  
)

export default component.exports